<template>
  <div class="space-y-4">
    <div class="">
      <img :src="personData.icon" class="w-5rem h-5rem rounded-full m-auto" @click="selectImage" />
      <p class="text-gray-400 text-center">{{ $t("点击更换头像") }}</p>
    </div>

    <el-row :gutter="22" class="flex">
      <el-col :span="4" class="pt-2">{{ $t("昵称") }}</el-col>
      <el-col :span="12">
        <el-input :placeholder="$t('请输入昵称')" v-model="personData.name"></el-input>
      </el-col>
      <el-col :span="4">
        <div class="h-5"></div>
      </el-col>
    </el-row>
    <el-row :gutter="22">
      <el-col :span="4" class="pt-2">{{ $t("手机号") }}</el-col>
      <el-col :span="12" v-if="phone_show">
        <el-input v-model="user.phone" :disabled="phone_show" :placeholder="$t('请输入手机号')"></el-input>
      </el-col>
      <el-col :span="12" v-else class="space-y-2">
        <el-input :placeholder="$t('请输入手机号')" v-model="phone_revision">
          <el-select slot="prepend" :placeholder="$t('区号')" v-model="codes" class="w-7rem">
            <el-option v-for="item in areaCode" :key="item.id" :label="`${item.value}(${item.key})`"
              :value="item.key"></el-option>
          </el-select>
        </el-input>
        <el-input :placeholder="$t('请输入验证码')" v-model="bindPhoneCode"></el-input>
        <el-button type="primary" size="mini" @click="confirmPhone">{{
          $t("确认绑定")
        }}</el-button>
      </el-col>
      <el-col :span="3" v-if="phone_show" class="pt-2 cursor-pointer">
        <span @click="phone_show = false">{{ $t("换绑") }}</span>
      </el-col>
      <el-col :span="8" class="space-x-2 pt-2 cursor-pointer" v-else>
        <span @click="sendVertifyPhone" v-if="phoneCode_show" class="text-main">{{ $t("发送验证码") }}</span>
        <span v-else>{{ $t("等待") }}{{ count_phone }}s</span>
        <span @click="(phone_show = true) && (phoneCode_show = true)">{{
          $t("取消")
        }}</span>
      </el-col>
    </el-row>
    <el-row :gutter="22">
      <el-col :span="4" class="pt-2">{{ $t("邮箱") }}</el-col>
      <el-col :span="12" v-if="email_show">
        <el-input :placeholder="$t('请输入邮箱')" v-model="user.email" :disabled="email_show"></el-input>
      </el-col>
      <el-col :span="12" v-else class="space-y-2">
        <el-input :placeholder="$t('请输入邮箱')" :disabled="email_show" v-model="email_revision"></el-input>
        <el-input :placeholder="$t('请输入验证码')" v-model="bindEmailCode"></el-input>
        <el-button type="primary" size="mini" @click="confirmEmail">{{
          $t("确认绑定")
        }}</el-button>
      </el-col>
      <el-col :span="3" v-if="email_show" class="pt-2 cursor-pointer">
        <span @click="email_show = false">{{ $t("换绑") }}</span>
      </el-col>
      <el-col :span="8" class="space-x-2 pt-2 cursor-pointer" v-else>
        <span @click="sendVerifyEmail" v-if="code_show" class="text-main">{{
          $t("发送验证码")
        }}</span>
        <span v-else>{{ $t("等待") }}{{ count_email }}s</span>
        <span @click="(email_show = true) && (code_show = true)">{{
          $t("取消")
        }}</span>
      </el-col>
    </el-row>
    <el-row :gutter="22">
      <el-col :span="4">{{ $t("性别") }}</el-col>
      <el-col :span="20">
        <el-radio-group v-model="personData.gender">
          <el-radio :label="1">{{ $t("男") }}</el-radio>
          <el-radio :label="0">{{ $t("女") }}</el-radio>
          <el-radio :label="-1">{{ $t("保密") }}</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <div class="text-right">
      <el-button @click="$emit('changeCancel')">{{ $t("取消") }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t("保存") }}</el-button>
    </div>
  </div>
</template>
<script>
import {
  computed,
  ref,
  watchEffect,
  reactive,
  onMounted,
} from "@vue/composition-api";
export default {
  setup(props, ctx) {
    const user = computed(() => ctx.root.$store.getters.user);
    const personData = reactive({
      icon: user.value.icon,
      name: user.value.name,
      phone: user.value.phone,
      email: user.value.email,
      gender: user.value.gender,
    });
    //头像
    const email_revision = ref();
    const phone_revision = ref();
    const phone_show = ref(true);
    const email_show = ref(true);
    const codes = ref();
    const areaCode = ref();
    onMounted(async () => {
      const res = await ctx.root.$lazy("datadic");
      areaCode.value = res.countryareacode;
    });
    watchEffect(() => { });
    const check_phone = () => {
      phone_show.value = false;
    };

    const regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    const regPhone = /[0-9]+/
    // /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    const regCode = /^-?\d+\.?\d*$/;
    //发送手机验证码
    const sendVertifyPhone = async () => {
      if (regPhone.test(phone_revision.value) && codes.value) {
        await ctx.root
          .$callapi("sendVerifyPhone", {
            phone: codes.value + '-'+ phone_revision.value,
            usetype: "bind",
          })
          .then((res) => {
            if (res.code === 0) {
              whenSendcode_phone();
            }
          });
      } else if (regPhone.test(phone_revision.value) && !codes.value) {
        ctx.root.$toast(ctx.root.$t("请选择区号"), "error");
      } else {
        ctx.root.$toast(ctx.root.$t("手机号格式错误"), "error");
      }
    };
    //发送邮箱验证码
    const sendVerifyEmail = async () => {
      if (regEmail.test(email_revision.value)) {
        await ctx.root
          .$callapi("sendVerifyEmail", {
            email: email_revision.value,
            usetype: "bind",
          })
          .then((res) => {
            if (res.code === 0) {
              whenSendcode_email();
            }
          });
      } else {
        ctx.root.$toast(ctx.root.$t("邮箱格式错误"), "error");
      }
    };
    const code_show = ref(true);
    const phoneCode_show = ref(true);
    const count_phone = ref();
    const count_email = ref();
    const whenSendcode_email = () => {
      ctx.root.$doing(ctx.root.$t("验证码已发送"));
      code_show.value = false;
      ctx.root.$done();
      const countDown = 60;
      count_email.value = countDown;
      const timer = setInterval(() => {
        if (count_email.value > 0 && count_email.value <= 60) {
          count_email.value--;
        } else {
          code_show.value = true;
          clearInterval(timer);
        }
      }, 1000);
    };
    const whenSendcode_phone = () => {
      ctx.root.$doing(ctx.root.$t("验证码已发送"));
      phoneCode_show.value = false;
      ctx.root.$done();
      const countDown = 60;
      count_phone.value = countDown;
      const timer = setInterval(() => {
        if (count_phone.value > 0 && count_phone.value <= 60) {
          count_phone.value--;
        } else {
          phoneCode_show.value = true;
          clearInterval(timer);
        }
      }, 1000);
    };
    //选择头像
    const selectImage = async () => {
      const res = await ctx.root.$chooseImages();

      if (!res) return;
      personData.icon = res.path;
    };

    //绑定邮箱
    const bindEmailCode = ref("");
    const confirmEmail = async () => {
      if (
        regEmail.test(email_revision.value) &&
        regCode.test(bindEmailCode.value)
      ) {
        ctx.root.$doing();
        const res = await ctx.root.$callapi("user/bindContactInfo", {
          email: email_revision.value,
          verifycode: bindEmailCode.value,
        });
        ctx.root.$done();
        if (res.code == 0) {
          ctx.root.$store.commit("SET_USER", res.data);
          ctx.root.$toast(ctx.root.$t("修改成功"), "success");
          email_show.value = true;
          code_show.value = true;
        }
      } else {
        ctx.root.$toast(ctx.root.$t("邮箱或验证码格式不正确"), "warning");
      }
    };
    //绑定手机号

    const bindPhoneCode = ref("");
    const confirmPhone = async () => {
      if (
        regPhone.test(phone_revision.value) &&
        regCode.test(bindPhoneCode.value)
      ) {
        ctx.root.$doing();
        const res = await ctx.root.$callapi("user/bindContactInfo", {
          phone: codes.value + '-' + phone_revision.value,
          verifycode: bindPhoneCode.value,
        });
        ctx.root.$done();
        if (res.code == 0) {
          ctx.root.$toast(ctx.root.$t("修改成功"), "success");
          ctx.root.$store.commit("SET_USER", res.data);
          phone_show.value = true;
          phoneCode_show.value = true;
        }
      } else {
        ctx.root.$toast(ctx.root.$t("手机号或验证码格式不正确"), "warning");
      }
    };
    const submitForm = async () => {
      await ctx.root.$autoUploads(personData, "icon");
      const res = await ctx.root.$callapi("user/savePersonalInfo", personData);
      if (res && res.data) {
        ctx.root.$store.commit("SET_USER", res.data);
        ctx.root.$toast(ctx.root.$t("保存成功"), "success");
        ctx.emit("save_message");
      }
    };

    return {
      user,
      phone_show,
      email_show,
      personData,
      submitForm,
      check_phone,
      email_revision,
      phone_revision,
      sendVerifyEmail,
      sendVertifyPhone,
      code_show,
      phoneCode_show,
      count_email,
      count_phone,
      selectImage,
      confirmEmail,
      confirmPhone,
      bindEmailCode,
      bindPhoneCode,
      codes,
      areaCode,
    };
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
};
</script>
<style scoped lang="scss"></style>
